import { memo } from 'react';
import { PaginationTopAnchor } from '../../../../core/components/Pagination';
import ProductListBreadcrumbs from './ProductListBreadcrumbs';

const PageHeader = ({
    rootLinks = [],
    title,
    description,
}: {
    rootLinks?: {
        text?: string;
        messageId?: string;
        to?: string;
    }[];
    title?: string;
    description?: string;
}) => {
    return (
        <div>
            {!rootLinks.find(item => item.to === '/sale') && (
                <PaginationTopAnchor />
            )}
            <ProductListBreadcrumbs
                description={description}
                title={title}
                rootLinks={rootLinks}
            />
        </div>
    );
};

export default memo(PageHeader);
